import { useState } from "react";
import { AdminDefaultLayout } from "../layouts/adminDefaultLayout";

import { AdminAddUserFormComponent } from "../components";

import { AdminUserModal } from "../components";

import Modal from "react-bootstrap/Modal";
import { AdminInstance } from "../utils/adminClass";
// const userFormData = [
//   {
//     name: '',
//     type: 'text',
//   },
//   {
//     email: '',
//     type: 'email',
//   },
// ];

const columns = [
  { header: "Name", propName: "username" },
  { header: "Email", propName: "email" },
  { header: "Seeds", propName: "seeds" },
  // Add other columns as needed
];

const actions = [
  {
    name: "Edit",
    method: (item: any) => {
      /* handle edit */
    },
  },
  {
    name: "Delete",
    method: (item: any) => {
      /* handle delete */
    },
  },
];

export const AdminUsersComponent = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [inputs, setInputs] = useState({});

  const handleFormButtonClick = () => {
    setFormOpen(!formOpen);
  };

  // handles user selection and open modal
  const handleUserSelection = (user: any) => {
    console.log("user", user);
    setSelectedUser(user);
    setUserModalOpen(true);
  };

  const handleGenerateCodes = async () => {
    console.log("generate codes");
    const res = await AdminInstance.generateCodes();
    console.log("res");
  };

  return (
    <>
      <AdminDefaultLayout
        openForm={handleFormButtonClick}
        formButtonTitle="User"
        actions={actions}
        columns={columns}
        header={"Users"}
        searchType="user"
        onItemSelect={handleUserSelection}
      ></AdminDefaultLayout>

      {/* TODO: MAKE THIS REUSABLE ACROSS ALL OF THE ADD FORMS */}
      <Modal show={formOpen} onHide={handleFormButtonClick} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminAddUserFormComponent closeForm={handleFormButtonClick} data={[]} setInputs={setInputs} />
        </Modal.Body>
      </Modal>
      {userModalOpen && (
        <AdminUserModal
          user={selectedUser}
          setSelectedUser={setSelectedUser}
          onClose={() => setUserModalOpen(false)}
          isModalOpen={userModalOpen}
        />
      )}
      <p onClick={handleGenerateCodes}>.</p>
    </>
  );
};
